import React from 'react';
import { formattedDate } from 'components/Map/util';

import styles from './DateSelector.module.css';
import { useTranslation } from 'react-i18next';

interface Props {
  dates: string[];
  isRecommended?: boolean;
  onDateSelect: (date: string) => void;
  activeDate: string;
}

export const DateSelector: React.FC<Props> = ({
  dates,
  onDateSelect,
  activeDate,
  isRecommended,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.selectorContainer}>
      <div className={styles.innerContainer}>
        {dates.map((date, index) => (
          <div
            key={date}
            className={`${styles.dateContainer} ${date === activeDate ? styles.selected : ''}`}
            tabIndex={0}
            role="button"
            onClick={() => onDateSelect(date)}
          >
            <div className={styles.dateContent}>
              <div className={styles.dayText}>{t('Day {{count}}', { count: index + 1 })}</div>
              {!isRecommended && (
                <div className={styles.dateText}>
                  {formattedDate(date, 'D MMM YYYY', i18n.language)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
